import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapExpandingSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapexpanding: {
      group: 'inline',
      inline: true,
      clampCondition: true,
      content: 'inline*',
      definingForContent: true,
      parseDOM: [{
        tag: 'MadCap\\:expanding',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:expanding',
      // specContent: 'madcapexpandinghead madcapexpandingbody'
    },

    madcapexpandinghead: {
      group: 'inline',
      inline: true,
      content: 'inline*',
      defining: true,
      linkBucket: 'expanding_text',
      parseDOM: [{
        tag: 'MadCap\\:expandingHead',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:expandingHead',
      // specContext: 'madcapexpanding'
    },

    madcapexpandingbody: {
      group: 'inline',
      inline: true,
      content: 'inline*',
      definingForContent: true,
      linkBucket: 'expanding_text',
      parseDOM: [{
        tag: 'MadCap\\:expandingBody',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:expandingBody',
      // specContext: 'madcapexpanding'
    }
  } satisfies Record<string, NodeSpec>;
}
